import { StyledButton } from "../styled-button/StyledButton";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsDownloading } from "../../store/slices/ExportSlice";
import {
  Avatar,
  CircularProgress,
  createStyles,
  Grid,
  makeStyles,
} from "@material-ui/core";
import * as DataService from "../../firebase/DataService";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import GetAppIcon from "@material-ui/icons/GetApp";
import ErrorIcon from "@material-ui/icons/Error";
import CloudDoneIcon from "@material-ui/icons/CloudDone";
import * as FileService from "../../firebase/FileService";

const useStyles = makeStyles(() =>
  createStyles({
    publishMessage: {
      margin: "1rem 0",
      background: "#00000040",
      padding: "1rem 1rem",
      listStyle: "none",
      borderRadius: "1rem",
      fontWeight: "600",
    },
  })
);

const Export = () => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const configMap = useSelector((state) => state);

  const [isPublishing, setIsPublishing] = React.useState(false);
  const [publishResult, setPublishResult] = React.useState("");

  const download = () => {
    dispatch(setIsDownloading(true));
  };

  const publishModel = async () => {
    setIsPublishing(true);

    const uid = configMap.app.id;

    const configMapCopy = JSON.parse(JSON.stringify(configMap));

    configMapCopy.model.model.src = await FileService.uploadFile(
      "models",
      uid,
      configMap.model.model
    );

    if (configMap.environment.environmentImage.src !== "") {
      const environmentImageUrl = await FileService.uploadFile(
        "environment",
        uid,
        configMap.environment.environmentImage
      );
      configMapCopy.environment.environmentImage.src =
        environmentImageUrl + "#.hdr";
    }

    try {
      await DataService.pushDataToCollection(
        "models",
        {
          configMap: JSON.stringify(configMapCopy),
        },
        uid
      );
      setPublishResult("success");
    } catch (e) {
      setPublishResult("fail");
    }
    setIsPublishing(false);
  };

  const getUrl = () =>
    window.location.protocol +
    "//" +
    window.location.host +
    "/view/" +
    configMap.app.id;

  return (
    <>
      <h6 className={"p-3"}>Download Poster</h6>
      <div className="inner-box">
        <Grid container className={"p-3"}>
          <Grid item xs={12}>
            Download an image of the model
            <StyledButton
              variant={"contained"}
              color={"primary"}
              onClick={download}
              startIcon={<GetAppIcon />}
            >
              Download poster
            </StyledButton>
          </Grid>
        </Grid>
      </div>
      <h6 className={"p-3"}>Publish Model</h6>
      <div className="inner-box">
        <Grid container className={"p-3"}>
          <Grid item xs={12}>
            Publish the model to get a permalink
            <StyledButton
              variant={"contained"}
              color={"primary"}
              onClick={publishModel}
              startIcon={
                isPublishing ? (
                  <CircularProgress
                    color="inherit"
                    style={{ height: "1rem", width: "1rem" }}
                  />
                ) : (
                  <CloudUploadIcon />
                )
              }
            >
              {isPublishing ? "Publishing" : "Publish"}
            </StyledButton>
          </Grid>
        </Grid>
        {publishResult !== "" && (
          <div className={"py-1 px-3"} style={{ maxWidth: "443px" }}>
            <div className={classes.publishMessage}>
              <Grid container>
                <Grid item xs={3} md={2}>
                  <Avatar>
                    {publishResult === "success" ? (
                      <CloudDoneIcon color={"primary"} />
                    ) : (
                      <ErrorIcon color="secondary" />
                    )}
                  </Avatar>
                </Grid>
                <Grid item xs={9} md={10} style={{ wordBreak: "break-all" }}>
                  {publishResult === "success" ? (
                    <div>
                      Published successfully. Permanent link -{" "}
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={getUrl()}
                      >
                        {getUrl()}
                      </a>
                    </div>
                  ) : (
                    "Error in publishing. Please try again."
                  )}
                </Grid>
              </Grid>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Export;
